import Scenes from "oc-threejs/Scenes";
import FullHeightDragable from "./FullHeightDragable";

export default class Tuer extends FullHeightDragable {
  constructor(vsData) {
    super(vsData);
    // JVI: Ist kaum sichtbar.
    // Verhindert aber bei geschlossener Tür, dass dahinterliegende Interieur hovern.
    this.dragBox.position.z = 2;
  }

  onDragBegin() {
    super.onDragBegin();
    this.vsData.isDropped = false;
    APP.model.showDoorsClosed(true);
  }

  vsUpdate() {
    super.vsUpdate();
  }

  onDrop() {
    super.onDrop();
    const tuer = this.vsData;
    const element = tuer.element;
    const schrank = tuer.schrank;

    if (!element) {
      return;
    }

    const elementSize = tuer.getElementBox(element).getSize();

    // :D so viel Code für so wenig Logik...

    const sideFromAngle =
      schrank.angleSide === "right"
        ? "links"
        : schrank.angleSide === "left"
          ? "rechts"
          : null;

    let allowedSidesFromVerdeckung =
      element.verdecktVonElementen.length > 0
        ? /links/
        : element.verdecktAnderenSchrank
          ? /rechts/
          : /.*/;

    let eckschrankCanDrop = true;
    if (APP.arrangement.Modell.Name === "Eckschrank") {
      //eckschrankCanDrop = (((element.verdecktVonElementen.length > 0 || element.verdecktAnderenSchrank !== null) && tuer.product.reiter === 'Standard') || (!element.unverdeckt.linksVerdeckt && !element.unverdeckt.rechtsVerdeckt));
      if (element.isEckElement) {
        eckschrankCanDrop = tuer.product.reiter === "Standard";
      }

      allowedSidesFromVerdeckung = /.*/;
      if (element.verdecktVonElementen.length > 0) {
        if (schrank.schenkel === "links") {
          allowedSidesFromVerdeckung = element.unverdeckt.linksVerdeckt
            ? /rechts/
            : /links/;
        } else {
          allowedSidesFromVerdeckung = element.unverdeckt.rechtsVerdeckt
            ? /links/
            : /rechts/;
        }
      } else if (element.verdecktAnderenSchrank !== null) {
        if (schrank.schenkel === "links") {
          allowedSidesFromVerdeckung = element.verdecktAnderenSchrank
            .elemente[0].unverdeckt.linksVerdeckt
            ? /links/
            : /rechts/;
        } else {
          allowedSidesFromVerdeckung = element.verdecktAnderenSchrank
            .elemente[0].unverdeckt.rechtsVerdeckt
            ? /rechts/
            : /links/;
        }
      }
    }
    const epsilon = 0.0002;
    const productSide = product => product.Art.substringBefore(":");
    const canFillTop = product => productSide(product) === sideFromAngle;
    const currentDoorCanFillTop = canFillTop(tuer.product);
    const elementTopIsNearSlopeTop =
      Math.abs(tuer.box.max.y - element.slopeTop) < 5;
    const betterFillToTop =
      element.frontSloped && elementTopIsNearSlopeTop && !currentDoorCanFillTop;
    const canDrop =
      tuer.product.BreiteMin <= elementSize.x &&
      elementSize.x <= tuer.product.BreiteMax &&
      allowedSidesFromVerdeckung.test(productSide(tuer.product)) &&
      eckschrankCanDrop;

    // const allowedReiter =
    //   element.verdecktVonElementen.length > 0 ||
    //   element.verdecktAnderenSchrank !== null
    //     ? "Standard"
    //     : tuer.product.reiter;

    const matchingDoors = APP.findProductsByType("Tuer").filter(
      x =>
        // x.reiter === allowedReiter &&
        x.BreiteMax > elementSize.x - epsilon &&
        x.BreiteMin < elementSize.x + epsilon &&
        allowedSidesFromVerdeckung.test(productSide(x))
    );

    const matchingDoorsFillToTop = matchingDoors.filter(canFillTop);
    if (!canDrop && matchingDoors.length === 0) {
      // hier passt gar keine Tür - wieso filtern wir das eigentlich nicht im InteractionHandler vor?
      APP.uiHandler.dialog({
        title: I18N("doorAlternativeHeader"),
        text: I18N("doorAlternativeTextNone"),
        buttons: [{ style: "primary", label: I18N("OK") }]
      });
      tuer.removeFromElement();
      Scenes.remove(this);
      return;
    }

    const setDoor = (door, toTop) =>
      APP.model.tryCompile(() => {
        tuer.isDropped = true;
        if (toTop) {
          tuer.box.max.y = element.box.max.y;
          tuer.size.copy(tuer.box.getSize());
          tuer.position.copy(tuer.box.getCenter());
        }
        tuer.setFromProduct(door);
      });

    if (!canDrop) {
      // Überprüfung ob die Tür bis Top gehen kann
      if (matchingDoorsFillToTop.length > 0) {
        setDoor(matchingDoorsFillToTop[0], true);
      } else {
        setDoor(matchingDoors[0], false);
      }
    }
    this.vsData.isDropped = true;

    //
    // if (!canDrop) {
    //     // die Tür passt hier gar nicht rein. Wir haben aber Alternativen zur Auswahl.
    //     // FIXME warum ein Array, aber wir nehmen nur das erste?
    //     const fillToTop = betterFillToTop && matchingDoorsFillToTop.length > 0;
    //     const doors = fillToTop ? matchingDoorsFillToTop : matchingDoors;
    //     if (doors.length>0) {
    //         // APP.uiHandler.dialog({
    //         //     title: I18N('doorAlternativeHeader'),
    //         //     text: I18N('doorAlternativeTextSelect', doors[0].Name + ' ' + doors[0].reiter),
    //         //     buttons: [
    //         //         {
    //         //             style: 'primary', label: I18N('Yes'),
    //         //             click: () => setDoor(doors[0],fillToTop)
    //         //         },
    //         //         {
    //         //             style: 'default', label: I18N('No'), click: () => {
    //         //                 tuer.removeFromElement();
    //         //                 Scenes.remove(this);
    //         //             }
    //         //         },
    //         //     ]
    //         // });
    //     }
    //     return;
    // }
    //
    // if (betterFillToTop && matchingDoorsFillToTop.length > 0) {
    //     // die Tür passt zwar, aber wir könnten einen Türtyp nehmen, der bis ganz nach oben geht.
    //     // Wir fragen den User, ob er das lieber möchte.
    //     // FIXME warum ein Array, aber wir nehmen nur das erste?
    //     APP.uiHandler.dialog({
    //         title: I18N('doorOptionalAlternativeHeader'),
    //         text: I18N('doorOptionalAlternativeTextSelect', matchingDoorsFillToTop[0].Name),
    //         buttons: [
    //             {
    //                 style: 'primary', label: I18N('Yes'), click: ()=>setDoor(matchingDoorsFillToTop[0],betterFillToTop)
    //             },
    //             {
    //                 style: 'default', label: I18N('No'),
    //             },
    //         ]
    //     });
    //     return;
    // }
    //
    //
    // if (betterFillToTop && matchingDoorsFillToTop.length === 0) {
    //     // die Tür passt zwar, aber kann die Schräge nicht ausfüllen, und wir haben auch keine Alternative zur Auswahl.
    //     // Wir teilen das dem User bit.
    //     APP.uiHandler.dialog({
    //         title: I18N('Tür passt nicht ganz'),
    //         text: I18N('Die Tür kann nur bis zum Kniestock gehen, weil das Element zu breit für eine einflügellige Tür ist'),
    //         buttons: [
    //             {
    //                 style: 'default', label: I18N('OK'), click: () => {
    //                     this.vsData.isDropped = true;
    //                 }
    //             },
    //         ]
    //     });
    //     return;
    // }
  }
}
